/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  LeverageGetHistoricalInterestRatesOptions,
  LeverageGetHistoricalInterestRatesStatus200,
  LeverageGetHistoricalInterestRatesStatus400,
  LeverageGetHistoricalInterestRatesStatus401,
  LeverageGetHistoricalInterestRatesStatus500,
} from '../types/LeverageGetHistoricalInterestRates'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { leverageGetHistoricalInterestRates } from '../clients/leverageGetHistoricalInterestRates'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const leverageGetHistoricalInterestRatesQueryKey = ({
  path,
  query,
}: Omit<LeverageGetHistoricalInterestRatesOptions, 'headers'>) =>
  [
    { url: '/v1/leverage/interest_rate/:asset_id/historical', params: path },
    ...(query ? [query] : []),
  ] as const

type LeverageGetHistoricalInterestRatesQueryKey = ReturnType<
  typeof leverageGetHistoricalInterestRatesQueryKey
>

export function leverageGetHistoricalInterestRatesQueryOptions(
  { path, query }: LeverageGetHistoricalInterestRatesOptions,
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = leverageGetHistoricalInterestRatesQueryKey({ path, query })
  return queryOptions<
    LeverageGetHistoricalInterestRatesStatus200,
    ResponseErrorConfig<
      | LeverageGetHistoricalInterestRatesStatus400
      | LeverageGetHistoricalInterestRatesStatus401
      | LeverageGetHistoricalInterestRatesStatus500
    >,
    LeverageGetHistoricalInterestRatesStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return leverageGetHistoricalInterestRates({
        ...config,
        path,
        query,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary Get historical leverage borrowing and lending yields for a specific asset
 * {@link /v1/leverage/interest_rate/:asset_id/historical}
 */
export function useLeverageGetHistoricalInterestRates<
  TData = LeverageGetHistoricalInterestRatesStatus200,
  TQueryData = LeverageGetHistoricalInterestRatesStatus200,
  TQueryKey extends QueryKey = LeverageGetHistoricalInterestRatesQueryKey,
>(
  {
    path,
    query,
  }: {
    path:
      | LeverageGetHistoricalInterestRatesOptions['path']
      | (() => LeverageGetHistoricalInterestRatesOptions['path'])
    query?:
      | LeverageGetHistoricalInterestRatesOptions['query']
      | (() => LeverageGetHistoricalInterestRatesOptions['query'])
  },
  options: {
    query?: Partial<
      QueryObserverOptions<
        LeverageGetHistoricalInterestRatesStatus200,
        ResponseErrorConfig<
          | LeverageGetHistoricalInterestRatesStatus400
          | LeverageGetHistoricalInterestRatesStatus401
          | LeverageGetHistoricalInterestRatesStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = {
    path: typeof path === 'function' ? path() : path,
    query: typeof query === 'function' ? query() : query,
  }
  const queryKey =
    resolvedOptions?.queryKey ?? leverageGetHistoricalInterestRatesQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...leverageGetHistoricalInterestRatesQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | LeverageGetHistoricalInterestRatesStatus400
      | LeverageGetHistoricalInterestRatesStatus401
      | LeverageGetHistoricalInterestRatesStatus500
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
